<template>
  <div class="files-list">
    <template v-for="(file, index) in content">
      <div
        v-if="file.id"
        :key="index"
        class="files-item d-flex align-center mb-2"
      >
        <div class=" file-icon">
         <file class="mr-2" />
        </div>
        <a class="text-decoration-none" target="_blank" :href="getLink(file)">{{
          file.title
        }}</a>
        <download class="ml-auto svg-file" style="width: 100px" />
      </div>
    </template>
  </div>
</template>
<script>
import serviceDataAccess from '../../services/service.data-access'
import Download from '../_shared/svg/Download.vue'
import File from '../_shared/svg/File.vue'
export default {
  name: 'Files',
  components: {
    File,
    Download
  },
  props: {
    model: {
      required: true
    }
  },
  computed: {
    content: (vm) => vm.model.content
  },
  methods: {
    async donwload(item) {
      const file = await serviceDataAccess.getFile(item.id)
      const link = document.createElement('a')
      link.href = URL.createObjectURL(file)
      link.download = decodeURI(file.name)
      link.setAttribute('target', '_blank')
      link.click()
      URL.revokeObjectURL(link.href)
    },
    getLink(item) {
      return `${this.$store.getters.getApiBasePath}/file/${item.id}`
    }
  }
}
</script>
.<style lang="scss" scoped>
.files-list {
  &.fit {
    padding: 1rem;
  }

  .files-item {
    border: 1px solid #cecece;
    padding: 1rem;
    font-size: 1.8rem;
    cursor: pointer;

    &:hover {
      span {
        text-decoration: underline;
      }
    }

    a {
      color: black;
    }
  }
  .file-icon {
    width: 22px;
    height: 30px;
    margin: 0px 16px 0px 18px;
  }
}
</style>
